import { environment } from "src/environments/environment";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { ResponseModel } from "../../../models/SharedModels/response.model";
import { IMaterialReceiptRefundRepository } from "./IMaterialReceiptRefundRepository";
import { MaterialReceiptRefund, ProductRefundImportFilter } from "src/app/models/Production/material-receipt-refund";

@Injectable(
    {
        providedIn: "root"
    }
)
export class MaterialReceiptRefundRepository extends GenericRepository<MaterialReceiptRefund> implements IMaterialReceiptRefundRepository {

    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/MaterialReceiptRefund', environment.urlAddress);
    }

    GetAll(currentPage: number, recordsPerPage: number, filterText: string): Observable<any> {
        filterText = (filterText || '').split('/').join('~').trim();
        if (filterText === "") {
            filterText = "|";
        } else {
            filterText = encodeURIComponent(filterText);
        }

        return this.Get('SelectAll' + '/' + currentPage + '/' + recordsPerPage + '/' + filterText).pipe(map(this.extractData), catchError(this.handleError));
    }

    SelectPostingSetup(postingSetup: any, godownCode: string): Observable<ResponseModel> {
        return this.PostData('/SelectPostingSetup' + '/' + godownCode, postingSetup).pipe(map(this.extractData), catchError(this.handleError));
    }

    SaveRec(item: MaterialReceiptRefund): Observable<ResponseModel> {
        return this.PostData('/SaveRec', item).pipe(map(this.extractData), catchError(this.handleError));
    }

    DeleteRec(invoiceNumber: string): Observable<ResponseModel> {
        return this.Delete('DeleteRec/' + invoiceNumber).pipe(map(this.extractData), catchError(this.handleError));
    }

    NavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
        return this.Get('NavRec/' + navType + '/' + currentIndex).pipe(map(this.extractData), catchError(this.handleError));
    }

    GetRec(invoiceNumber: string): Observable<ResponseModel> {
        return this.Get('GetRec/' + invoiceNumber).pipe(map(this.extractData), catchError(this.handleError));
    }

    ProductRefundSearch(filter: ProductRefundImportFilter): Observable<ResponseModel> {
        return this._http.post(this.url + 'api/MaterialReceiptRefund/ProductRefundSearch', filter, this.httpOptions).pipe(
            map(this.extractData),
            catchError((error) => {
                if (error && error.error && typeof error.error === 'object') {
                    return of(error.error);
                }
                return this.handleError(error);
            }));
    }

    ProductRefundSearchDetail(sessionId: number): Observable<ResponseModel> {
        return this.Get('ProductRefundSearchDetail/' + sessionId).pipe(map(this.extractData), catchError(this.handleError));
    }
}